import { ApiRef, createApiRef } from '@backstage/frontend-plugin-api';
import type {
  InternalendpointsGetSessionResponse,
  InternalendpointsModelDetails,
  InternalendpointsModelSummary,
  InternalendpointsSessionSummary,
  InternalModelsGetRequest,
  InternalSessionsGetRequest,
} from '@internal/backstage-plugin-neo4j-graph-analytics-common';

export interface SessionsListResponse {
  sessions: InternalendpointsSessionSummary[];
  totalCount: number;
}

export interface ModelsListResponse {
  models: InternalendpointsModelSummary[];
  totalCount: number;
}

export type SessionDetailResponse = InternalendpointsGetSessionResponse;

export type ModelDetailResponse = InternalendpointsModelDetails;

export interface SessionTelemetryResponse {
  sessionId?: string;
  phaseTransitions?: { [phase: string]: string };
}

export interface AGASessionsAPI {
  listSessions(
    params?: InternalSessionsGetRequest,
  ): Promise<SessionsListResponse>;
  getSession(sessionId: string): Promise<SessionDetailResponse>;
  getSessionTelemetry(sessionId: string): Promise<SessionTelemetryResponse>;
  listModels(params?: InternalModelsGetRequest): Promise<ModelsListResponse>;
  getModel(modelId: string): Promise<ModelDetailResponse>;
}

export const agaSessionsApiRef: ApiRef<AGASessionsAPI> =
  createApiRef<AGASessionsAPI>({
    id: 'plugin.neo4j-graph-analytics.sessions.service',
  });
